import { useMemo } from 'react';

import { createInitialRocketUrl } from '@/util';
import { rocketCacheBustingIdAtom } from '@hooks/useApp';
import { useAtomValue } from 'jotai';

type IFrameProps = {
  rocketBaseURL: string;
};

export default function RocketIFrame({ rocketBaseURL }: IFrameProps) {
  const rocketCacheBustingId = useAtomValue(rocketCacheBustingIdAtom);

  const rocketUrl = useMemo(
    () => createInitialRocketUrl(rocketBaseURL, rocketCacheBustingId),
    [rocketBaseURL, rocketCacheBustingId]
  );

  return (
    <iframe
      id="volman-rocket-iframe"
      data-testid="volman-rocket-iframe"
      name="volman-rocket-iframe"
      title={`Loading Rocket in calling view`}
      style={{ width: '100%', flexGrow: 1, border: 0 }}
      src={rocketUrl}
    />
  );
}
